// extracted by mini-css-extract-plugin
module.exports = {"container":"SavedTab_container__MnTAC","title":"SavedTab_title__APvu2","loader":"SavedTab_loader__wowIO"};